import { CountryFilterOptionInformation, FilterKey } from '@studyportals/search-filters';
import { FilterOptionsBase } from './FilterOptionsBase';
import { PortalType } from '@studyportals/domain-client';
import { CountryPresenter } from '@/presenters/CountryPresenter';

export class CountryOptions extends FilterOptionsBase {
	public override getFilterKey(): FilterKey {
		return FilterKey.COUNTRY;
	}

	public override createOptions(): CountryFilterOptionInformation[] {
		return CountryPresenter.allOptions();
	}

	public getValuesForIsoCodes(isoCodes: readonly string[]): string[] {
		return CountryPresenter.idsOfIsoCodes(isoCodes);
	}

	public getTopCountries(portalType: PortalType): string[] {
		switch (portalType) {
			case PortalType.DISTANCE_LEARNING:
				return ['82', '30', '202', '56', '11'];
			case PortalType.SHORT:
				return ['82', '30', '1', '202', '15'];
			case PortalType.PHD:
				return ['30', '82', '27', '24', '12'];
			default:
				return ['30', '82', '202', '11', '56'];
		}
	}
}
